

module.exports = {
    login:'логин',
    loginByAccount:'Дансны нэвтрэх',
    inputAccount:'Дансны дугаарыг оруулна уу',
    inputPassword:'Нууц үгээ оруулна уу',
    verificationCode:'Каптча',
    forgotPassword:'Нууц үгээ март',
    experience:'Бүртгэлгүй туршлага',
    loginTitle1:'Хүчин чадалшил ажиллагаа',
    loginTitle2:'Үйл явц нь тодорхой',
    loginTitle3:'Санхүүгийн хатуу',
    loginTitle4:'Мэдээллийн үзүүлэлт',
    lastTime:'Сүүлийн нэвтрэх цаг',
    waitTodo:'Тогтворнэх',
    remember:'Нууц үгийг санаарай',
    //按钮
    search:'хайх',
    reset:'нөөц',
    add:'нэмэх',
    save:'хадгалах',
    templateDownload:'Загвар татаж авах',
    importGoods:'Импортын бараа',
    addGoods:'Борлуулалт нэмэх',
    edit:'Шалгах',
    delete:'устгах',
    copy:'хуулах',
    examine:'шалгах',
    revocation:'өөрчлөлт',
    confirm:'батлах',
    inStorage:'Агуулах',
    outStorage:'Агуулахаас гарсан',
    print:'Хэвлэх',
    exportDocument:'Баримтыг экспортлох',
    saveDraft:'Ноорог хадгалах',
    close:'Хаах',
    reject:'Татгалзах',
    createNewProduct:'Шинэ бараа үүсгэх',
    approved:'Батлагдсан',
    historicalSalesPrice:'Түүхэн борлуулалтын үнэ',
    historicalPurchasePrice:'Түүхэн худалдан авалтын үнэ',
    export:'Экспорт хийх',
    generateInboundOrder:'Орлогын баримт үүсгэх',
    cancle:'Цуцлах',
    confirmInbound:'Орлогыг баталгаажуулах',
    confirmOutbound:'Гаралтыг баталгаажуулах',
    EorD:'Идэвхжүүлэх/Идэвхгүй Болгох',
    batchImport:'Бөөнөөр Импортлох',
    batchEdit:'Бөөнөөр Засварлах',
    enable:'Идэвхжүүлэх',
    disable:'Идэвхгүй Болгох',
    inquiryRecords:'Үнийн Асууруудын Бүртгэл',
    barcode:'Баркод',
    //表格
    No:'No.',
    documentNumber:'Дизиг мэдэхгүй',
    warehouse:'агуулах',
    supplier:'сэлбэг',
    supplierInformation: 'Нийлүүлэгчийн мэдээлэл',
    client:'үйлчлүүлэгч',
    commodityAmount:'Барааны хэмжээ',
    otherAmount:'Бусад хэмжээ',
    totalAmount:'Нийт мөнгөн дүн',
    status:'улс гурэн',
    createTime:'Бүтээгдэхүүний цаг',
    completionTime:'Дуусгах цаг',
    startTime:'эхлэх цаг',
    endTime:'дуусах хугацаа',
    operator:'Нээлттэй -person',
    approver:'Зөвшөөрөл авагч',
    deliveryTime: 'Барааны хугацаа',
    remark:'Тайлбар',
    operate:'мэс засал хийх',
    goodsName:'барааны нэр',
    goodsId:'Ажлын ID',
    brand:'брэнд',
    category:'зэрэглэл',
    select:'сонгоно уу',
    amountPayable:'Төлөх',
    amountReceivable:'Авах боломжтой',
    paymentMethod:'Төлбөрийн аргууд',
    quantity:'тоо хэмжээ',
    unitPrice:'нэгжийн үнэ',
    amount:'хэмжээ',
    storageLocation:'Барааны агуулах',
    unit:'нэгж',
    internalCode:'Хувь нийтээ',
    specification:'онцлог',
    approvalComments:'Батлах санал',
    details:'Дэлгэрэнгүй мэдээлэл',
    inventoryQuantity:'Бараа материалын тоо хэмжээ',
    historicalPrice:'Түүхэн үнэ',
    amountPaid:'Төлсөн мөнгөн дүн',
    creator:'Үүсгэгч',
    phoneNum:'Гар утасны дугаар',
    customerInformation:'Харилцагчийн мэдээлэл',
    basicInformation:'Үндсэн мэдээлэл',
    contactPerson:'Холбогдох хүн',
    image:'Зураг',
    retailPrice:'Жижиглэнгийн Үнэ',
    wholesalePrice:'Бөөний Үнэ',
    otherPrice:'Бусад Үнүүд',
    foreignName:'Гадаад Нэр',
    itemLength:'Урт(mm)',
    itemWide:'Өргөн(mm)',
    itemHigh:'Өндөр(mm)',
    itemWeight:'Цэвэр жин(Kg)',
    defectiveQuantity:'Сул Тохиргооны Тоо',
    otherOccupation:'Бусад Оролцоо',
    availableQuantity:'Боломжит Тоо',
    changeTime:'Өөрчлөлтийн Цаг',
    landline:'Гар Утас',
    fax:'Факс',
    address:'Хаяг',
    bankOfAccount:'Тамга Уулзах Банк',
    bankAccountNumber:'Банкны Дансны Дугаар',
    taxNum:'Татварын Дугаар',
    //提示
    operationSuccessful:'Амжилттай үйлдэл',
    pleaseAddProduct:'Бараа нэмнэ үү',
    unitNotBeNull:'Тоо хэмжээ болон нэгж үнэ хоосон байж болохгүй',
    quantityNotBeDecimal:'Тоо хэмжээ бол тэмдэггүй байх ёсгүй',
    unitPriceNotBeNegative:'Нэгж үнэ сөрөг байж болохгүй',
}